
(() => {

  const key = Symbol.for('celia-june.real-homes');
  if (window[key]) return;
  window[key] = true;
  const instances = new WeakMap();

  function initialize(root) {

    if (!root || instances.has(root)) return;

    const viewport = root.querySelector(
      '.cj-real-homes__viewport'
    );

    const track = root.querySelector(
      '.cj-real-homes__track'
    );

    const originals = [
      ...track.querySelectorAll('.cj-real-homes__slide')
    ];

    const prev = root.querySelector(
      '.cj-real-homes__arrow--prev'
    );

    const next = root.querySelector(
      '.cj-real-homes__arrow--next'
    );

    const dots = [
      ...root.querySelectorAll('.cj-real-homes__dot')
    ];

    const count = originals.length;

    if (count < 2 || !prev || !next) return;


    /* CREATE CAROUSEL CLONES */

    const cloneCount = 3;

    function clone(item) {

      const node = item.cloneNode(true);

      node.removeAttribute('data-shopify-editor-block');
      node.removeAttribute('data-shopify-editor-section');

      node.setAttribute('aria-hidden', 'true');

      node.querySelectorAll('[id]').forEach(el => {
        el.removeAttribute('id');
      });

      node.querySelectorAll('a,button').forEach(el => {
        el.setAttribute('tabindex', '-1');
      });

      return node;
    }

    const before = [];
    const after = [];

    for (let i = cloneCount; i > 0; i--) {

      before.push(
        clone(originals[
          (count - i % count) % count
        ])
      );

    }

    for (let i = 0; i < cloneCount; i++) {

      after.push(
        clone(originals[i % count])
      );

    }

    track.prepend(...before);
    track.append(...after);


    /* CAROUSEL STATE */

    const items = [...track.children];

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const autoplay =
      root.dataset.autoplay === 'true' &&
      !reducedMotion.matches;

    const interval = Math.max(
      3000,
      Number(root.dataset.interval) || 5000
    );

    let position = cloneCount;
    let moving = false;

    let timer = null;
    let fallback = null;

    let visible = true;
    let hovering = false;
    let focusInside = false;

    let touchStartX = null;
    let touchStartY = null;


    /* CURRENT PHOTO */

    function currentIndex() {

      return (
        (position - cloneCount) % count + count
      ) % count;

    }


    /* UPDATE DOTS */

    function updateDots() {

      const current = currentIndex();

      dots.forEach((dot, i) => {

        dot.classList.toggle(
          'is-active',
          i === current
        );

        dot.setAttribute(
          'aria-current',
          i === current ? 'true' : 'false'
        );

      });

    }


    /* ALIGN THE TRACK */

    function align(animated) {

      track.style.transition =
        animated && !reducedMotion.matches
          ? ''
          : 'none';

      track.style.transform =
        `translate3d(${-items[position].offsetLeft}px,0,0)`;

      updateDots();

    }


    /* INFINITE LOOP */

    function normalize() {

      if (!moving) return;

      clearTimeout(fallback);
      fallback = null;

      if (position >= cloneCount + count) {
        position -= count;
      }

      if (position < cloneCount) {
        position += count;
      }

      align(false);

      moving = false;

    }


    /* MOVE CAROUSEL */

    function move(delta) {

      if (moving) return;

      moving = true;

      position += delta;

      align(true);

      if (reducedMotion.matches) {

        normalize();

      } else {

        fallback = setTimeout(
          normalize,
          700
        );

      }

    }


    /* AUTOPLAY */

    function stopTimer() {

      if (timer !== null) {
        clearInterval(timer);
      }

      timer = null;

    }

    function startTimer() {

      stopTimer();

      if (
        autoplay &&
        visible &&
        !hovering &&
        !focusInside &&
        !document.hidden
      ) {

        timer = setInterval(
          () => move(1),
          interval
        );

      }

    }

    function interact(delta) {

      move(delta);
      startTimer();

    }

    function onVisibility() {

      if (document.hidden) {
        stopTimer();
      } else {
        startTimer();
      }

    }


    /* TRANSITIONS */

    track.addEventListener(
      'transitionend',
      event => {

        if (
          event.target === track &&
          event.propertyName === 'transform'
        ) {
          normalize();
        }

      }
    );


    /* ARROWS */

    prev.addEventListener(
      'click',
      () => interact(-1)
    );

    next.addEventListener(
      'click',
      () => interact(1)
    );


    /* DOT NAVIGATION */

    dots.forEach((dot, i) => {

      dot.addEventListener(
        'click',
        () => {

          if (moving) return;

          moving = true;

          position = cloneCount + i;

          align(true);

          if (reducedMotion.matches) {

            normalize();

          } else {

            fallback = setTimeout(
              normalize,
              700
            );

          }

          startTimer();

        }
      );

    });


    /* MOBILE SWIPE */

    viewport.addEventListener(
      'touchstart',
      event => {

        touchStartX =
          event.changedTouches[0].clientX;

        touchStartY =
          event.changedTouches[0].clientY;

      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      event => {

        if (touchStartX === null) return;

        const dx =
          event.changedTouches[0].clientX -
          touchStartX;

        const dy =
          event.changedTouches[0].clientY -
          touchStartY;

        if (
          Math.abs(dx) > 45 &&
          Math.abs(dx) > Math.abs(dy)
        ) {

          interact(dx < 0 ? 1 : -1);

        }

        touchStartX = null;
        touchStartY = null;

      },
      { passive: true }
    );


    /* PAUSE AUTOPLAY ON INTERACTION */

    root.addEventListener(
      'mouseenter',
      () => {

        hovering = true;
        stopTimer();

      }
    );

    root.addEventListener(
      'mouseleave',
      () => {

        hovering = false;
        startTimer();

      }
    );

    root.addEventListener(
      'focusin',
      () => {

        focusInside = true;
        stopTimer();

      }
    );

    root.addEventListener(
      'focusout',
      event => {

        if (!root.contains(event.relatedTarget)) {

          focusInside = false;
          startTimer();

        }

      }
    );

    document.addEventListener(
      'visibilitychange',
      onVisibility
    );


    /* PAUSE WHEN NOT VISIBLE */

    let observer = null;

    if ('IntersectionObserver' in window) {

      observer = new IntersectionObserver(
        entries => {

          visible = entries[0].isIntersecting;
          startTimer();

        },
        { threshold: 0.1 }
      );

      observer.observe(root);

    }


    /* KEEP PHOTOS ALIGNED ON RESIZE */

    let resizeObserver = null;

    const onResize = () => align(false);

    if ('ResizeObserver' in window) {

      resizeObserver = new ResizeObserver(
        onResize
      );

      resizeObserver.observe(viewport);

    } else {

      window.addEventListener(
        'resize',
        onResize
      );

    }


    /* SHOPIFY EDITOR CLEANUP */

    function cleanup() {

      stopTimer();
      clearTimeout(fallback);

      document.removeEventListener(
        'visibilitychange',
        onVisibility
      );

      if (observer) {
        observer.disconnect();
      }

      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {

        window.removeEventListener(
          'resize',
          onResize
        );

      }

      instances.delete(root);

    }

    instances.set(root, cleanup);

    align(false);
    startTimer();

  }


  /* INITIAL LOAD */

  function boot() {

    document.querySelectorAll('.cj-real-homes').forEach(initialize);

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();

  }


  /* SHOPIFY SECTION RELOAD */

  document.addEventListener(
    'shopify:section:load',
    event => {

      const root =
        event.target.matches('.cj-real-homes')
          ? event.target
          : event.target.querySelector('.cj-real-homes');

      initialize(root);

    }
  );


  /* SHOPIFY SECTION UNLOAD */

  document.addEventListener(
    'shopify:section:unload',
    event => {

      const root =
        event.target.matches('.cj-real-homes')
          ? event.target
          : event.target.querySelector('.cj-real-homes');

      if (root) {
        const cleanup = instances.get(root);
        if (cleanup) cleanup();
      }

    }
  );

})();
